import WorkAvailabilityPage from './WorkAvailability.page';

export default WorkAvailabilityPage;
